import type { Plugin } from 'unified';
import type { Node } from 'unist';
import { visit } from 'unist-util-visit';

const supportedCustomDirectives = ['a', 'cta', 'quote', 'img', 'video', 'instagram', 'carousel'];

export const customDirective: Plugin<[], Node> = () => {
  return (tree) => {
    visit(tree, (node) => {
      if (
        (node.type === 'leafDirective' || node.type === 'containerDirective' || node.type === 'textDirective') &&
        'name' in node &&
        typeof node.name === 'string'
      ) {
        if (supportedCustomDirectives.indexOf(node.name) < 0) {
          return;
        }

        const data = node.data || (node.data = {});
        const attributes = (node as any).attributes || {};

        (data as any).hName = node.name;
        (data as any).hProperties = attributes;
      }
    });
  };
};
